import React, { useEffect, useState } from 'react';
import { Bell, Plus, ArrowRight, MoveUpRight, Search, ChevronUp, ChevronDown, Eye, EyeOff, Download, X, EllipsisVerticalIcon, Info, FileDown } from 'lucide-react';
import TagCostInfoModal from '../../components/common/TagCostInfoModal';
import FitmentCertificateModal from '../../components/common/FitmentCertificateModal';
import logo1 from '../../assets/videos.png';
import logo4 from '../../assets/agent.png';
import logo2 from '../../assets/activat.png';
import logo3 from '../../assets/stock.png';
import car from '../../assets/images/container.png';
import fastag from '../../assets/fastaglogo.png';
import { Button } from '../../Common/Button';
import hiicon from '../../assets/images/hi.png';
import FastagPurchase from '../../Commponent/FastagPurchase';
import AgentFastagRequest from '../../Commponent/AgentFastagRequest';
import CommonTable from '../../Common/CommonTable';
import AddAgent from '../../Commponent/AddAgent';
import AddBulkAgents from '../../Commponent/AddBulkAgents';
import { getVehicleClassData } from '../../Utils/helper';
import { vehicleClasses } from '../../Utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIONS } from '../../redux/actions';
import { ErrorToast, SuccessToast } from '../../Utils/toast';
import { render } from '@testing-library/react';
import moment from 'moment';
import CommonModal from '../../Commponent/CommonModal';
import { API } from '../../Common/Api';
import { useNavigate } from 'react-router-dom';
import { buildStyles, CircularProgressbar, CircularProgressbarWithChildren } from 'react-circular-progressbar';

const AgentsDashboard = () => {
  const dispatch = useDispatch();
  const GetFastag = useSelector((state) => state.GetFastag.GetFastagData);
  const GetAgentFastag = useSelector((state) => state.GetAgentFastag.GetAgentFastagData);
  const agentSummary = useSelector((state) => state.GetAgentSummary.GetAgentSummaryData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [show, setShow] = useState(false);
  const [addMenuOpen, setAddMenuOpen] = useState(false);
  const [addAgentsOpen, setAddAgentsOpen] = useState(false);
  const [addBulkAgentsOpen, setAddBulkAgentsOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [checkGetFastag, setCheckGetFastag] = useState(false);
  const [checkGetAgentFastag, setCheckGetAgentFastag] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [approvalNote, setApprovalNote] = useState('');
  // const [sortKey, setSortKey] = useState("");
  // const [sortOrder, setSortOrder] = useState("asc");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: null });
  const [selectedTagRefId, setSelectedTagRefId] = useState(null);

  const [userData, setUserData] = useState(null);

  const [progressData, setProgressData] = useState([
    { label: 'Received FASTag', value: 0, count: 0, gradient: ['#fca5a5', '#ef4444'] },
    { label: 'Activated FASTag', value: 0, count: 0, gradient: ['#10b981', '#6ee7b7'] },
    { label: 'Available FASTag', value: 0, count: 0, gradient: ['#3b82f6', '#93c5fd'] },
  ]);

  const gradientDefs = (id, [startColor, endColor]) => (
    <defs>
      <linearGradient id={id} gradientTransform="rotate(90)">
        <stop offset="0%" stopColor={startColor} />
        <stop offset="100%" stopColor={endColor} />
      </linearGradient>
    </defs>
  );

  useEffect(() => {
    if (agentSummary?.status === 200 && agentSummary?.success) {
      const { totalFastag, ActivatedFASTag, availableFASTag } = agentSummary.data;
      setProgressData([
        { label: "Received FASTag", value: totalFastag?.count > 0 ? Math.min(100, totalFastag?.percentage || 0) : 0, count: totalFastag?.count || 0, gradient: ["#fca5a5", "#ef4444"] },
        { label: "Activated FASTag", value: ActivatedFASTag?.count > 0 ? Math.min(100, ActivatedFASTag?.percentage || 0) : 0, count: ActivatedFASTag?.count || 0, gradient: ["#10b981", "#6ee7b7"] },
        { label: "Available FASTag", value: availableFASTag?.count > 0 ? Math.min(100, availableFASTag?.percentage || 0) : 0, count: availableFASTag?.count || 0, gradient: ["#3b82f6", "#93c5fd"] },
      ]);
    }
  }, [agentSummary]);

  useEffect(() => {
    getData()
    getDataInit()
    dispatch(ACTIONS.GetAgentSummaryAction());
  }, [refreshCount]);


  const getDataInit = async () => {
    const data = localStorage.getItem('UserDetail');


    setUserData(JSON.parse(data));
  }

  const getData = () => {
    let params = {
      page: 1,
      limit: 10,
    }
    setCheckGetAgentFastag(true)
    dispatch(ACTIONS.GetAgentFastagAction(params));
  }

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction:
            prev.direction === "asc"
              ? "desc"
              : prev.direction === "desc"
                ? null
                : "asc",
        };
      }
      return { key, direction: "asc" };
    });
  };
  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "asc")
        return (
          <ChevronUp className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
      if (sortConfig.direction === "desc")
        return (
          <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#9C9C9C]" />
        );
    }
    return (
      <ChevronDown className="w-[18px] h-[18px] inline-block ml-1 text-[#E0E0E0]" />
    );
  };

  useEffect(() => {
    if (checkGetFastag) {
      if (GetFastag?.status == 200 && GetFastag?.success) {
        setTableData(GetFastag?.data.data?.length > 5 ? GetFastag?.data.data.slice(0, 5) : GetFastag?.data.data);
        // setTableData(data);
      } else {
        ErrorToast(GetFastag?.message);
      }
      setCheckGetFastag(false)
      // setLoading(false);
    }
  }, [GetFastag])

  useEffect(() => {
    if (checkGetAgentFastag) {
      if (GetAgentFastag?.status == 200 && GetAgentFastag?.success) {
        // Extract records array from API response
        const data = GetAgentFastag?.data?.records || [];
        const processedData = Array.isArray(data) && data.length > 5 ? data.slice(0, 5) : (Array.isArray(data) ? data : []);
        setTableData(processedData);
      } else {
        ErrorToast(GetAgentFastag?.message);
        setTableData([]);
      }
      setCheckGetAgentFastag(false)
    }
  }, [GetAgentFastag])

  // Debug tableData changes
  useEffect(() => {
  }, [tableData])

  const [assigningAgent, setAssigningAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleVisibility = (index, row) => {
    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    if (window.innerWidth >= 0) {
      setModalOpen(!isVisible);
    }

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);

  const tableColumns = [
    {
      label: "Received By",
      key: "receivedBy",
      render: (row) => (
        <div>
          <div className="font-medium text-[#1F1715]">{row.assignedTo?.username}</div>
          <div className="text-xs text-[#000000]">
            <sub style={{ fontSize: "12px", color: 'gray' }}>+91 {row.assignedTo?.mobileNo}</sub>
          </div>
        </div>
      ),
    },
    {
      label: "tagRefId",
      render: (row) => {
        const tagVal = row.tagRefId || '';
        return (
          <div className="flex items-center gap-2">
            <span>{tagVal}</span>
            {tagVal && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedTagRefId(tagVal);
                }}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-red-500 focus:outline-none"
                title="View pricing details"
              >
                <Info size={14} />
              </button>
            )}
          </div>
        );
      }
    },
    {
      label: "Status",
      render: (row) => (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${row.agentStatus === 'Assigned' ? 'bg-green-100 text-green-900' :
          row.agentStatus === 'Activated' ? 'bg-green-100 text-green-800' :
            'bg-gray-100 text-gray-800'
          }`}>
          {(row.agentStatus == "Assigned") ? "Available" : (row.agentStatus == "Unassigned" && "Activated") || "Unassigned"}
        </span>
      )
    },
    {
      label: "Batch ID",
      render: (row) => row.batchId
    },
    {
      label: (
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => handleSort("vehicleClass")}
        >
          Vehicle Class {getSortIcon("vehicleClass")}
        </div>
      ),
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px]"
            />
            <p>{vehicleClassData.value}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? <Eye className="h-5 w-5" /> : <EyeOff className="h-5 w-5" />}
            </div>
          </div>
        );
      },
    },
    {
      label: "Received Date",
      render: (row) => moment(row.agentAssignedDate).format("DD MMMM, YYYY, hh:mm A"),
      tdClassName: 'flex justify-end'
    }
  ];

  const statsData = [
    { id: 1, title: "Total Purchased FASTags", value: "N/A", iconColor: logo1 },
    { id: 2, title: "Activated FASTags", value: "N/A", iconColor: logo2 },
    { id: 3, title: "Available Stock", value: "N/A", iconColor: logo3 },
    { id: 4, title: "Assigned to Agents", value: "N/A", iconColor: logo4 }
  ];

  // Profile data
  const profileData = {
    name: "Your Profile",
    status: userData?.username || userData?.role,
    phone: userData?.mobileNo ? `+91 ${userData.mobileNo}` : '',
    message: "Continue your journey and achieve your target",
  };


  const handleApprove = async () => {
    const data = {
      FasTagIds: [assigningAgent._id],
      remark: approvalNote
    }

    const response = await API.ApproveFastag(JSON.stringify(data));

    if (response.status === 200 && response.success) {
      SuccessToast(response.message);
      dispatch({ type: "REFRESH_DATA" });
      setIsModalOpen(false);
    } else {
      ErrorToast(response.message);
    }

  }
  const navigate = useNavigate();
  const [fitmentOpen, setFitmentOpen] = useState(false);

  return (
    <div className=" ">
      {fitmentOpen && <FitmentCertificateModal onClose={() => setFitmentOpen(false)} />}
      <div className=" mx-auto">

        {/* Top Section: Progress Charts + Profile */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 ">

          {/* Charts */}
          <div className="lg:col-span-3   " style={{ height: "100vh !important" }}>
            <div className="flex justify-end mb-4">
              <Button
                label="Download Fitment Certificate"
                icon={<FileDown className="w-4 h-4" />}
                iconPosition="right"
                roundedButton={true}
                onClick={() => setFitmentOpen(true)}
                style={{ backgroundColor: "#EE3B31", fontWeight: "700" }}
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
              {progressData.map((item, idx) => {
                const gradientId = `gradient-${idx}`;
                return (
                  <div key={idx} className="flex flex-col items-center">
                    <div className="w-32 h-32 md:w-36 md:h-36 xl:w-44 xl:h-44">
                      <CircularProgressbarWithChildren
                        value={item.value}
                        strokeWidth={10}
                        styles={buildStyles({
                          pathColor: `url(#${gradientId})`,
                          trailColor: "#f3f3f3",
                          strokeLinecap: "round",
                        })}
                      >
                        <svg style={{ height: 0 }}>
                          {gradientDefs(gradientId, item.gradient)}
                        </svg>
                        <div className="text-xl font-semibold text-black">
                          {item.count}
                        </div>
                      </CircularProgressbarWithChildren>
                    </div>
                    <p className="mt-3 text-base text-gray-600 text-center">
                      {item.label}
                    </p>
                  </div>
                );
              })}
            </div>
            <div className="mt-6 ">

              <div className="mt-10">
                <div className="bg-white rounded-t-2xl shadow-sm border border-gray-100 border-b-0">
                  <div className="flex justify-between items-center px-6 py-[18px]">
                    <div className="flex items-center gap-3">
                      <span className="w-1.5 h-6 rounded-full bg-[#EE3B31]"></span>
                      <h2 className="text-lg font-semibold text-gray-900">Recent Received FASTags</h2>
                    </div>
                    {/* <button
                      onClick={() => navigate('/fastag-activation')}
                      title="View all"
                      className="group rounded-full w-9 h-9 flex justify-center items-center bg-[#F5F5F5] hover:bg-[#EE3B31] transition-colors"
                    >
                      <MoveUpRight className="w-[18px] h-[18px] text-[#EE3B31] group-hover:text-white transition-colors" />
                    </button> */}
                  </div>
                </div>

                <CommonTable className="w-full" columns={tableColumns} data={Array.isArray(tableData) ? tableData : []} emptyMessage="No Inventory Found" />
              </div>
            </div>
          </div>

          {/* Profile Card */}
          <div className="lg:col-span-1 space-y-6  lg:block hidden">
            <div className="relative overflow-hidden bg-white rounded-2xl shadow-sm border border-gray-100 min-h-[444px]">
              {/* gradient header banner */}
              <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-br from-[#EE3B31] to-rose-400"></div>
              <div className="relative flex flex-col min-h-[444px] p-[25px]">
                <div className="flex items-center justify-between mb-8">
                  <h3 className="font-semibold text-white text-lg md:text-xl">{profileData.name}</h3>
                </div>

                <div className="flex justify-center mb-4">
                  <div className="p-1.5 rounded-full bg-white shadow-lg ring-4 ring-white">
                    <div className="w-20 h-20 rounded-full bg-gradient-to-br from-rose-50 to-indigo-50 flex items-center justify-center">
                      <img src={hiicon} className="w-14 h-14 object-contain" onError={(e) => (e.target.style.display = 'none')} />
                    </div>
                  </div>
                </div>

                <div className="text-center mb-1">
                  <h4 className="text-xl font-bold text-gray-900 mb-1">{profileData.status}</h4>
                  <p className="text-gray-500 text-sm">{profileData.phone}</p>
                </div>

                <div className="text-center mt-2">
                  <p className="text-gray-500 text-sm leading-relaxed whitespace-pre-line px-2">
                    {profileData.message}
                  </p>
                </div>

                <button
                  className="mt-6 w-full bg-emerald-500 hover:bg-emerald-600 text-white py-3 rounded-full font-semibold flex items-center justify-center gap-2 transition-colors shadow-sm"
                  onClick={() => setShow(true)}
                >
                  <span className="text-sm font-bold">Raise FASTag Request</span>
                  <ArrowRight className="!w-[16px] !h-[16px]" />
                </button>

                <div className="mt-auto pt-6 border-t border-gray-100 text-center">
                  <img src={fastag} className="h-8 object-contain mx-auto" onError={(e) => (e.target.style.display = 'none')} />
                </div>
              </div>
            </div>
            <div
              className=" rounded-2xl lg:p-6 flex flex-col justify-between text-white lg:min-h-[158px] relative overflow-hidden"
              style={{
                backgroundImage: `url(${car})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="relative z-10">
                <div className='absolute top-[50px] left-[30%] transform -translate-x-1/2 -translate-y-1/2'>

                  <h3 className="text-xl font-bold mb-2">Track FASTag.</h3>
                  <p className="text-sm">Grow with Omnicard.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center px-4">
            <div className="relative bg-white rounded-2xl shadow-lg w-full max-w-xl p-6">
              <div className="absolute top-4 right-4 flex gap-3">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold text-center">{vehicleData?.value}</h2>
              <p className="text-sm text-center mb-6">{vehicleData?.description}</p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {show && <AgentFastagRequest onClose={() => { setShow(false); getData(); getDataInit(); dispatch(ACTIONS.GetAgentSummaryAction()); }} />}
        {selectedTagRefId && (
          <TagCostInfoModal
            tagRefId={selectedTagRefId}
            onClose={() => setSelectedTagRefId(null)}
          />
        )}
      </div>
    </div>

  );
};

export default AgentsDashboard;
